import { render } from "./internal-notes-input.vue?vue&type=template&id=9b7b8bfc&ts=true"
import script from "./internal-notes-input.ts?vue&type=script&lang=ts&external"
export * from "./internal-notes-input.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__